import { Divider, Text } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from '~/app/i18n/i18n';
import { StyledResult } from '~/app/pages/configurator/components/dialogs/car-matching-results-dialog/styles/styled-result-tile';
import { DealerInfo, SimilarCarCompareCriterion } from '~/graphql/__generated__/graphql';

export default function DifferencesAndLocation({
	isAvailableNow,
	missingFeatures,
	dealer,
}: {
	isAvailableNow: boolean;
	missingFeatures: SimilarCarCompareCriterion[];
	dealer: DealerInfo;
}) {
	const { i18n } = useI18n();
	return (
		<>
			<StyledResult>
				<div className="diff-group">
					<Text tag="p" variant={{ order: '4', style: 'bold' }}>
						{i18n('ngc.stockcar.matches.differing')}
					</Text>
					<ol>
						{missingFeatures?.slice(0, 3).map(({ text }, index: number) => (
							<Text tag="p" key={index} variant={{ order: '2', style: 'normal', type: 'copy' }}>
								<li dangerouslySetInnerHTML={{ __html: text }} />
							</Text>
						))}
					</ol>
				</div>
				{/*
				TODO: Uncomment when availability info is ready, currently we dont know what data to expect
				<Badge
					label={
						isAvailableNow
							? i18n('ngc.stockcar.matches.available.now')
							: i18n('ngc.stockcar.matches.available.soon')
					}
					semanticShape={isAvailableNow ? 'positive' : 'notice'}
					labelPosition="trailing"
					margin={['4px', 0, 0, 0]}
				/>*/}
				<Divider orientation="horizontal" margin={['16px', 0, '16px', 0]} />
				<Text tag="p" variant={{ order: '2', style: 'normal', type: 'copy' }}>
					{dealer.name}
				</Text>
				<Text tag="p" variant={{ order: '3', style: 'normal', type: 'copy' }}>
					{dealer.city}
				</Text>
			</StyledResult>
		</>
	);
}
